import React from "react";

export default function LinkIcon(props) {
  return (
    <svg viewBox="0 0 6.062 6.062" enableBackground="new 0 0 6.062 6.062">
      <path
        fill={props.color}
        d="m5.826,1.566l-1.556,1.573c-0.27,0.271-0.716,0.271-1.072,0.029l-.031,.031c0.24,0.359 0.239,0.81-0.03,1.082l-1.556,1.572c-0.313,0.317-0.867,0.268-1.238-0.107s-0.419-0.934-0.106-1.25l1.556-1.572c0.258-0.26 0.68-0.27 1.029-0.055l.049-.049c-0.213-0.353-0.204-0.779 0.054-1.039l1.557-1.572c0.312-0.317 0.867-0.268 1.238,0.107 0.371,0.375 0.418,0.934 0.106,1.25zm-3.803,1.805l-1.344,1.357c-0.186,0.188-0.186,0.492 0,0.678 0.185,0.189 0.486,0.189 0.671,0l1.344-1.357c0.132-0.131 0.165-0.319 0.112-0.485l-.615,.621-.336-.34 .592-.598c-0.149-0.028-0.308,0.007-0.424,0.124zm3.361-2.717c-0.185-0.186-0.486-0.186-0.672,1.11022e-16l-1.345,1.36c-0.116,0.117-0.15,0.277-0.122,0.428l.626-.633 .336,.34-.648,.656c0.164,0.053 0.35,0.02 0.481-0.113l1.344-1.357c0.185-0.189 0.185-0.491 0-0.681z"
      />
    </svg>
  );
}
